import { loginEventURL } from './config'

export async function submitLoginEvent(email) {
  if (!email) return { success: false, error: 'No email provided' }

  try {
    const response = await fetch(loginEventURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    })

    const data = await response.json()
    if (!response.ok) {
      console.error('[HubSpot] Login event failed:', data)
      return { success: false, error: data }
    }
    return { success: true, data }
  } catch (error) {
    console.error('[HubSpot] Login event error:', error)
    return { success: false, error: error.message }
  }
}

export async function submitToHubSpot(formData) {
  const PORTAL_ID = '43624639';
  const FORM_GUID = process.env.REACT_APP_HUBSPOT_FORM_GUID;

  if (!FORM_GUID) {
    console.error('[HubSpot] Form GUID not configured in .env');
    return { success: false, error: 'Form GUID not configured' };
  }

  try {
    // Get hubspotutk cookie for visitor tracking
    const hutkCookie = document.cookie.split(';').find(c => c.trim().startsWith('hubspotutk='));
    const hutk = hutkCookie ? hutkCookie.split('=')[1] : null;

    const payload = {
      submittedAt: Date.now().toString(),
      fields: [
        { objectTypeId: '0-1', name: 'email', value: formData.email },
        { objectTypeId: '0-1', name: 'firstname', value: formData.firstName },
        { objectTypeId: '0-1', name: 'lastname', value: formData.lastName },
        { objectTypeId: '0-1', name: 'signup_plans', value: formData.signupPlans },
        { objectTypeId: '0-1', name: 'signup_type', value: formData.signupType },
        {
          objectTypeId: '0-1',
          name: 'signup_data_type',
          value: Array.isArray(formData.dataType) ? formData.dataType.join(';') : formData.dataType
        }
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title,
        ...(hutk && { hutk })
      }
    };

    const response = await fetch(
      `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_GUID}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }
    );

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      console.error('[HubSpot] Form submission failed:', data);
      return { success: false, error: data };
    }
  } catch (error) {
    console.error('[HubSpot] Form submission error:', error);
    return { success: false, error: error.message };
  }
}
